// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADocumentContentDataElementsInner
 */
export interface DTADocumentContentDataElementsInner {
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentDataElementsInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentDataElementsInner
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DTADocumentContentDataElementsInner
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentDataElementsInner
     */
    type?: string;
}

/**
 * Check if a given object implements the DTADocumentContentDataElementsInner interface.
 */
export function instanceOfDTADocumentContentDataElementsInner(value: object): value is DTADocumentContentDataElementsInner {
    return true;
}

export function DTADocumentContentDataElementsInnerFromJSON(json: any): DTADocumentContentDataElementsInner {
    return DTADocumentContentDataElementsInnerFromJSONTyped(json, false);
}

export function DTADocumentContentDataElementsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContentDataElementsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'] == null ? undefined : json['name'],
        'required': json['required'] == null ? undefined : json['required'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function DTADocumentContentDataElementsInnerToJSON(json: any): DTADocumentContentDataElementsInner {
    return DTADocumentContentDataElementsInnerToJSONTyped(json, false);
}

export function DTADocumentContentDataElementsInnerToJSONTyped(value?: DTADocumentContentDataElementsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'required': value['required'],
        'type': value['type'],
    };
}
